import { render, staticRenderFns } from "./AgentsList.vue?vue&type=template&id=801e467c&"
import script from "./AgentsList.vue?vue&type=script&lang=js&"
export * from "./AgentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('801e467c')) {
      api.createRecord('801e467c', component.options)
    } else {
      api.reload('801e467c', component.options)
    }
    module.hot.accept("./AgentsList.vue?vue&type=template&id=801e467c&", function () {
      api.rerender('801e467c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/AgentsList.vue"
export default component.exports